<template>
  <gg-modal :is-active="opened" @close="close">
    <template v-slot:toolbar>
      Relinquish Access
    </template>
    <template v-slot:body>
      Are you sure you want to relinquish the access for “{{ service.product }}” - “{{ service.domain }}”?
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">
        Cancel
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
      <gg-btn primary :loading="loading" @click="deleteAccess">
        Delete
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteModal',
  data: () => ({
    loading: false
  }),
  props: {
    opened: {
      type: Boolean,
      required: true,
      default: false
    },
    service: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['relinquishSharedAccess', 'reportSuccess', 'reportError']),
    async deleteAccess () {
      try {
        this.loading = true
        const { resultmsg } = await this.relinquishSharedAccess({ service: this.service.id })
        this.reportSuccess(resultmsg)
        this.loading = false
        this.close()
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
